import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetCoupon = createAsyncThunk(
  "getCoupon/GetCoupon",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GetCouponApi);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetCouponSlice = createSlice({
  name: "GetCouponData",
  initialState: {
    GetCouponData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetCoupon.fulfilled, (state, action) => {
        state.GetCouponData = action.payload;
      })
      .addCase(GetCoupon.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetCouponSlice.reducer;
